import {useState, useEffect} from "react";
import {BasicDropdown} from "components/Dropdown";
import {useListCashierPreperation} from "hooks/AdminHospital/Medicine";

export function InputPreperation(props) {
	const {data: dataSediaanObat} = useListCashierPreperation({
		medicineId: props.medicineId,
		hospitalId: props.hospitalId,
		sortBy: "title.asc",
	});
	const [sediaanObatOptions, setSediaanObatOptions] = useState([]);

	useEffect(() => {
		if (dataSediaanObat?.success) {
			setSediaanObatOptions([
				{label: "-", value: null},
				...(dataSediaanObat.data.rows.map(item => ({label: item.title, value: item.id, objectData: item})) ||
					[]),
			]);
		}
	}, [dataSediaanObat]);

	return (
		<BasicDropdown
			className={"form-control"}
			data={sediaanObatOptions}
			name={props.name}
			returnObject={true}
			value={props.value}
			onSelect={props.onSelect}
		/>
	);
}
